export default __webpack_public_path__ + "static/media/joker.3f109cc3.png";